module.exports = __webpack_public_path__ + "static/youtube-64dbea6eb58f76393e40bf987d9a063f.png";